import { render, staticRenderFns } from "./collectionagentslist.vue?vue&type=template&id=ee22b596&"
import script from "./collectionagentslist.vue?vue&type=script&lang=js&"
export * from "./collectionagentslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports